import axios from "axios";
import { SHARE_JOB_TYPES } from "../constants/tags";

export const shareJob = async ( source: string, folderId: string | number | null ): Promise<boolean> => {
  if (folderId == null) {
    return false;
  }
  const url2share = `https://${getBaseServer()}/seeker/job-details?kId=${folderId}`;

  //   const stringObj = `{"FolderId": "${folderId}"}`;
  //   const postData = {
  //     func: 'getURLToShare',
  //     field: 'params',
  //     value: stringObj,
  //   };

  //   const postDataStr = new URLSearchParams(postData).toString();
  //   const dataUrl = `https://recruiter.${getBaseServer()}/v2/data.html`;

  try {
    // const response = await axios.post(dataUrl, postDataStr, {
    //   headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    // });

    // const requestData = response.data;
    // const locationUrl = requestData.LOCATION_URL || '';

    const title = "Check this out... Job opportunity in your country of origin";
    const summary = encodeURIComponent("Your share summary goes here");

    let shareURL = "";

    switch (source) {
      case SHARE_JOB_TYPES.LINKEDIN:
        const articleUrl = encodeURIComponent(url2share);
        shareURL = `https://www.linkedin.com/sharing/share-offsite?url=${articleUrl}`;
        break;
      case SHARE_JOB_TYPES.FACEBOOK:
        shareURL = `https://www.facebook.com/sharer/sharer.php?s=100&p[url]=${url2share}&p[title]=${title}`;
        break;
      case SHARE_JOB_TYPES.TWITTER:
        const tweetUrl = encodeURIComponent(url2share);
        const tweetText = encodeURIComponent(title);
        shareURL = `https://twitter.com/intent/tweet?url=${tweetUrl}&text=${tweetText}`;
        break;
      // Add cases for other sources as needed

      default:
        break;
    }

    if (shareURL) {
      window.open(
        shareURL,
        "mywindow",
        "menubar=1,resizable=1,width=450,height=350"
      );
    }

    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

const getBaseServer = () => {
  let host = window?.location.host;
  if (origin.includes("recruiter")) {
    host = host.replace("recruiter.", "");
  }
  return host;
};
